// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.breadcrumbs {
  background-color: rgb(145, 182, 27);
}
.breadcrumbs .container_title_page {
  margin: 0 auto;
  padding: 20px;
  max-width: 900px;
  text-align: center;
}
.breadcrumbs .container_title_page .title_page {
  margin: 0;
  color: rgb(255, 255, 255);
  font-family: "Century Gothic";
  font-weight: 600;
  font-size: 2.4rem;
  line-height: 3rem;
}
@media screen and (max-width: 991px) {
  .breadcrumbs .container_title_page .title_page {
    max-width: 720px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 480px) {
  .breadcrumbs .container_title_page .title_page {
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}
.breadcrumbs .breadcrumb .first_item {
  display: inline-block;
  list-style-type: none;
}
.breadcrumbs .breadcrumb .first_item a {
  color: rgb(255, 255, 255);
  text-decoration: none;
  font-family: "Roboto-Regular";
  font-size: 0.85em;
  font-weight: 600;
  text-transform: uppercase;
}
.breadcrumbs .breadcrumb .last_item {
  margin-left: 5px;
  color: rgb(255, 255, 255);
  display: inline-block;
  list-style: none;
  font-family: "Roboto-Regular";
  font-size: 0.85em;
  font-weight: 600;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/components/Breadcrumbs/Breadcrumbs.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;AATA;EACI,mCAAA;AAWJ;AATI;EACI,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAWR;AATQ;EACI,SAAA;EACA,yBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAWZ;AATY;EARJ;IASQ,gBAAA;IACA,cAAA;EAYd;AACF;AAVY;EAbJ;IAcQ,kBAAA;IACA,kBAAA;EAad;AACF;AATQ;EACI,qBAAA;EACA,qBAAA;AAWZ;AAVY;EACI,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAYhB;AARQ;EACI,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAUZ","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n\n.breadcrumbs {\n    background-color: rgb(145, 182, 27);\n\n    .container_title_page {\n        margin: 0 auto;\n        padding: 20px;\n        max-width: 900px;\n        text-align: center;\n\n        .title_page {\n            margin: 0;\n            color: rgb(255, 255, 255);\n            font-family: \"Century Gothic\";\n            font-weight: 600;\n            font-size: 2.4rem;\n            line-height: 3rem;\n\n            @media screen and (max-width: 991px) {\n                max-width: 720px;\n                margin: 0 auto;\n            }\n\n            @media screen and (max-width: 480px) {\n                font-size: 1.56rem;\n                line-height: 1.2em;\n            }\n        }\n    }\n    .breadcrumb {\n        .first_item {\n            display: inline-block;\n            list-style-type: none;\n            a {\n                color: rgb(255, 255, 255);\n                text-decoration: none;\n                font-family: \"Roboto-Regular\";\n                font-size: 0.85em;\n                font-weight: 600;\n                text-transform: uppercase;\n            }\n        }\n        \n        .last_item {\n            margin-left: 5px;\n            color: rgb(255, 255, 255);\n            display: inline-block;\n            list-style: none;\n            font-family: \"Roboto-Regular\";\n            font-size: 0.85em;\n            font-weight: 600;\n            text-transform: uppercase;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
